import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Safe HTML Pipe
 * Sanitizes HTML content to prevent XSS attacks while allowing safe HTML tags
 * Uses Angular's built-in sanitizer which removes dangerous content like:
 * - <script> tags
 * - Event handlers (onclick, onerror, etc.)
 * - javascript: URLs
 * - Data URLs in unsafe contexts
 *
 * SECURITY: This pipe uses sanitize() NOT bypassSecurityTrustHtml()
 * to ensure XSS protection is maintained.
 */
@Pipe({
	name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(html: string, sanitizeHtml = true): SafeHtml | null {
		if (!html) {
			return null;
		}

		if (!sanitizeHtml) {
			// sanitization is explicitly disabled in contentSection, use bypassSecurityTrustHtml
			return this.sanitizer.bypassSecurityTrustHtml(html);
		}

		// Use Angular's built-in HTML sanitizer to remove XSS vectors
		// This allows safe HTML tags (<p>, <strong>, <a href="...">)
		// while removing dangerous content (<script>, onclick="...", etc.)
		// Return as SafeHtml after sanitization
		return this.sanitizer.sanitize(SecurityContext.HTML, html);
	}
}
